module.exports = __webpack_public_path__ + "static/media/1.fab29479.svg";